import React from 'react'
import { useState } from 'react'
import { CreativeToolsProps } from './CreativeTools.types'
import { ShareCreativeModal } from './share-creative-modal/ShareCreativeModal'
import { DeleteCreativeModal } from './delete-creative-modal/DeleteCreativeModal'
import { DuplicateCreativeModal } from './duplicate-creative-modal/DuplicateCreativeModal'
import { AssetApprovalStatus } from '@marketing-milk/interfaces'
import ShareOutlined from '@mui/icons-material/ShareOutlined'
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined'
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined'
import { CardIconButton } from '../../CreativeCard/CardIconButton'

export function CreativeTools({ creative }: CreativeToolsProps) {
  const [showShareModal, setShareModal] = useState(false)
  const [showDeleteModal, setDeleteModal] = useState(false)
  const [showDuplicateModal, setDuplicateModal] = useState(false)

  function onToggleDelete() {
    setDeleteModal(_ => !_)
  }

  function onToggleShare() {
    setShareModal(_ => !_)
  }

  function onToggleDuplicate() {
    setDuplicateModal(_ => !_)
  }

  return (
    <>
      <CardIconButton
        label="Share to another business"
        icon={<ShareOutlined fontSize="small" />}
        onClick={onToggleShare}
      />
      <CardIconButton
        label="Duplicate"
        icon={<ContentCopyOutlined fontSize="small" />}
        onClick={onToggleDuplicate}
      />
      {creative.reviewStatus !== AssetApprovalStatus.Published && (
        <CardIconButton
          label="Delete"
          icon={<DeleteOutlineOutlined fontSize="small" />}
          onClick={onToggleDelete}
        />
      )}
      <DeleteCreativeModal
        creative={creative}
        isVisible={showDeleteModal}
        onToggle={onToggleDelete}
      />
      <ShareCreativeModal creative={creative} isVisible={showShareModal} onToggle={onToggleShare} />
      <DuplicateCreativeModal
        creative={creative}
        isVisible={showDuplicateModal}
        onToggle={onToggleDuplicate}
      />
    </>
  )
}
